export default __webpack_public_path__ + "static/media/dogira.abdd722c.jpg";